export const agenderlist = [
    { time: '1月8日晚上', desclist: ['POWER官方欢迎酒会'] },
    { time: '1月9日 上午', desclist: ['致辞：主办方致辞', '致辞：香港财政司司长致辞', '仪式：HK Web3 Hub落地数码', '致辞', '主题演讲：Metaverse and GameFi Ecosystem', '圆桌论坛：虚拟资产与香港的寒冬机遇', '圆桌讨论：不同监管体系下的虚拟资产发展路径'] },
    { time: '1月9日 下午', desclist: ['主题演讲：香港贸易、金融版图与虚拟资产的结合', '主题演讲：虚拟资产与创新金融机构的可能性', '圆桌讨论：虚拟资产持牌机构的产品设计', '主题演讲：新宏观范式下的虚拟资产价值修复', '主题演讲：从香港看全球：如何把握Web3时代机遇', '圆桌讨论：挥别2022阴霾，CeFi2023会改变什么', '主题演讲：2022区块链产业安全事件回顾与启示', '现场连线：虚拟资产交易平台的资产安全', '主题演讲：Web3的香港时刻', '圆桌讨论：虚拟资产矿业的冬天过去了吗'] },
    { time: '1月9日 晚上', desclist: ['POWER UP HONG KANG DRINK NIGHT'] },
    { time: '1月10日 上午', desclist: ['主题演讲：NFT市场与Web3世界不可忽视的十大关系', '圆桌讨论：2023年虚拟资产投资趋势', '主题演讲：区块链的去中心化技术世界忽视了什么', '圆桌讨论：以太坊2.0与新公链机会', '圆桌讨论：Web3入口革命——MPC钱包的体验与普及'] },
    { time: '1月10日下午', desclist: ['现场连线：如何面对今天的Wbe2的窘境时刻', '主题演讲：Web3必经之路：法币支付赛道', '圆桌讨论：游戏于社交拓展NFT资产', '主题演讲：元宇宙的奇点临近', '圆桌讨论：数码娱乐生态及机会', '主题演讲：Web3游戏聚合平台的价值', '主题演讲：香港集会，落地HK Web3 Hub', '圆桌讨论：Web3企业如何落地香港'] },
    { time: '1月10日 晚上', desclist: ['闭门交流晚宴'] }
]

export const guestlist = [
    {
        type: 0,
        list: [
            {
                name: 'Robert Leshner',
                brief: 'Founder of Compound',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/RobertLeshner.png'
            },
            {
                name: 'Sergey Nazarov',
                brief: 'Founder of Chainlink',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/SergeyNazarov.png'
            },
            {
                name: 'Sergej Kunz',
                brief: 'Co-Founder of 1inch',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/SergejKunz.png'
            },
            {
                name: 'Antonio',
                brief: 'Founder of dYdX',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/Antonio.png'
            },
            {
                name: 'Stani Kulechov',
                brief: 'Founder of Aave',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/StaniKulechov.png'
            },
            {
                name: 'Lin Li',
                brief: 'Huobi CEO',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/LinLi.png'
            },
            {
                name: 'Jihan Wu',
                brief: 'Co-founder of BitMain',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/JihanWu.png'
            },
            {
                name: 'Ronghui Gu',
                brief: 'Co-founder of Certik',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/RonghuiGu.png'
            },
            {
                name: 'Weiguang Liu',
                brief: 'Vice President of Ant Financial',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/WeiguangLiu.png'
            },
            {
                name: 'Bo Feng',
                brief: 'Founder of Dragonfly Capital',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/BoFeng.png'
            },
            {
                name: 'Justin Sun',
                brief: 'Founder of TRON',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/JustinSun.png'
            },
            {
                name: 'David Namdar',
                brief: 'Partner of Galaxy Digital',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/DavidNamdar.png'
            }
            // {
            //     name: 'Sam Bankman Fried',
            //     brief: 'Founder of FTX',
            //     icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/SamBankmanFried.png'
            // }
        ]
    },
    {
        type: 1,
        list: [
            {
                name: 'Baoqiu Cui',
                brief: 'Vice President of Xiaomi Group, Chairman of Group Technical Committee',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/BaoqiuCui.png'
            },
            {
                name: 'Menghan Wang',
                brief: 'Product Leader, OneConnect Blockchain Team, Ping An Finance',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/MenghanWang.png'
            },
            {
                name: 'Shihiro Yamaguchi',
                brief: 'Vice President, FinTech, SBI',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/ShihiroYamaguchi.png'
            },
            {
                name: 'Yao Liu',
                brief: 'Baidu Smart Cloud Blockchain Product Leader',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/YaoLiu.png'
            },
            {
                name: 'Jay Hao',
                brief: 'OKEx CEO',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/JayHao.png'
            },
            {
                name: 'Peter Vessennes',
                brief: 'Founding Chairman of the Bit Foundation',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/PeterVessennes.png'
            },
            {
                name: 'Reese Jones',
                brief: 'Co-founder of Singularity University',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/ReeseJones.png'
            },
            {
                name: 'Keith Teare',
                brief: 'Co-founder of TechCrunch',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/KeithTeare.png'
            },
            {
                name: 'Tom Ding',
                brief: 'Co-founder of Dfinity',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/TomDing.png'
            },
            {
                name: 'Vanessa Grellet',
                brief: 'general manager of ConsenSys / Managing Partner of Aglaé Ventures',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/VanessaGrellet.png'
            },
            {
                name: 'Franklin Urteaga',
                brief: 'Former Clinton Administration Technology Advisor',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/FranklinUrteaga.png'
            },
            {
                name: 'Katina Stefanova',
                brief: 'Former Bridgewater Fund Senior Executive Officer and Management Committee Advisor',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/KatinaStefanova.png'
            }
        ]
    },
    {
        type: 2,
        list: [
            {
                name: 'Eugenio Gomez',
                brief: 'Professor of Regulation at Harvard Law School and USTB',
                icon: 'https://hx24-prod.oss-cn-hongkong.aliyuncs.com/meeting/power-singapore20220823/Speaker/EugenioGomez.png'
            }
        ]
    }
]

export const guestLists = [
    {
        name: '陈茂波',
        brief: '香港特别行政区政府财政司司长 大紫荆勋，GBS，MH，JP',
        icon: require('./images/陈茂波.png')
    },
    {
        name: '陈浩濂',
        brief: '香港特别行政区\n财经事务及库务局副局长JP',
        icon: require('./images/陳浩濂.png')
    },
    {
        name: '吴杰庄',
        brief: '全国政协委员、立法会议员\nG-Rocket 高诺国际加速器 主席',
        icon: require('./images/吴杰庄.png')
    },
    {
        name: '陈细明',
        brief: '香港数码港\n董事局主席',
        icon: require('./images/陈细明.png')
    },
    {
        name: '任景信',
        brief: '香港数码港\n行政总裁',
        icon: require('./images/任景信.png')
    },
    {
        name: '刘会平',
        brief: '香港贸易发展局\n副总裁',
        icon: require('./images/刘会平.png')
    },
    {
        name: '王峰',
        brief: '火星财经 创始人\n Element 核心创始团队成员',
        icon: require('./images/王峰.png')
    },
    {
        name: 'Evan Au Yang',
        brief: 'Anoimoca Brands\n总裁',
        icon: require('./images/Evan Au Yang.png')
    },
    // {
    //     name: '冯波',
    //     brief: 'Dragonfly \n创始⼈',
    //     icon: require('./images/冯波.png')
    // },
    {
        name: '何一',
        brief: '币安 联合创始人\n CMO Binance Labs负责人',
        icon: require('./images/何一.png')
    },
    {
        name: '蔡文胜',
        brief: '美图\n董事⻓',
        icon: require('./images/蔡文胜.png')
    },
    {
        name: '孙宇晨',
        brief: '波场TRON 创始人，火必Huobi 全球顾问委员会成员',
        icon: require('./images/孙宇晨.png')
    },
    {
        name: '许炜',
        brief: '众安国际\n总裁',
        icon: require('./images/许炜.png')
    },
    {
        name: 'Lennix',
        brief: 'OKX \n全球机构业务部董事总经理',
        icon: require('./images/Lennix.png')
    },
    // {
    //     name: 'Haseeb Qureshi',
    //     brief: 'Dragonfly \n管理合伙人',
    //     icon: require('./images/Hassab.png')
    // },
    {
        name: 'Jack Yi',
        brief: 'LD Capital \n创始合伙⼈',
        icon: require('./images/Jack Yi.png')
    },
    {
        name: '王嘉平',
        brief: 'IDEA研究院讲席科学家',
        icon: require('./images/王嘉平.png')
    },
    // {
    //     name: '任煜男',
    //     brief: '欧科云链\n董事长&行政总裁',
    //     icon: require('./images/任煜男.png')
    // },
    // {
    //     name: '周硕基',
    //     brief: 'FBG创始合伙⼈',
    //     icon: require('./images/周硕基.png')
    // },
    {
        name: '孔剑平',
        brief: 'Nano Labs \n创始⼈',
        icon: require('./images/孔剑平.png')
    },
    {
        name: '顾荣辉',
        brief: 'CertiK 联合创始人\n哥伦比亚计算机系教授',
        icon: require('./images/顾荣辉.png')
    },
    {
        name: '王一鸣',
        brief: 'B.xyz \n创始人',
        icon: require('./images/王一鸣.png')
    },
    {
        name: 'Cynthia Wu',
        brief: 'Matrixport\n首席运营官',
        icon: require('./images/吴梦夏.png')
    },
    {
        name: 'Lily Z. King',
        brief: 'COBO \n首席运营官',
        icon: require('./images/Lily Z. King.png')
    },
    {
        name: 'Micheal',
        brief: 'Maicapital \n联合创始人',
        icon: require('./images/Micheal WONG.png')
    },
    {
        name: '王毅',
        brief: '南方东英\n董事总经理',
        icon: require('./images/王毅.png')
    },
    {
        name: '伍鸣',
        brief: 'Conflux Network\n联合创始人兼CTO',
        icon: require('./images/伍鸣.png')
    },
    {
        name: 'Wilson',
        brief: 'Ava Labs(Avalanche)\n亚洲区负责人',
        icon: require('./images/Wilson.png')
    },
    {
        name: 'Erich Wong',
        brief: 'The Sandbox\n香港业务增长主管',
        icon: require('./images/Erich Wong.png')
    },
    {
        name: 'Joy Lou',
        brief: 'LD Capital \n合伙⼈',
        icon: require('./images/Jay lou.png')
    },
    {
        name: '杨伟健',
        brief: '艾德金融\n首席运营官',
        icon: require('./images/杨伟健.png')
    },
    {
        name: '商思林',
        brief: '火星财经 联合创始人\nMCLOUDS 总裁',
        icon: require('./images/商思林.png')
    },
    {
        name: '任煜男',
        brief: '欧科云链控股（01499.HK）公司执行董事\n董事局主席&新政总裁',
        icon: require('./images/任煜男.png')
    },
    {
        name: '罗达江',
        brief: '德勤中国\n合伙人',
        icon: require('./images/罗达江.png')
    },
    {
        name: 'Vicnent Cheng',
        brief: 'Alchemy Pay\n社区负责人',
        icon: require('./images/Alex2.png')
    },
    // {
    //     name: 'Jonathan Zhu',
    //     brief: 'North Beta International \n创始合伙人',
    //     icon: require('./images/Johnathan Zhu.png')
    // },
    // {
    //     name: '施襄',
    //     brief: 'Alchemy Pay&BIA.network \n创始⼈',
    //     icon: require('./images/施襄.png')
    // },
    {
        name: '陈沛泉',
        brief: 'VDX \n联合创始人',
        icon: require('./images/陈沛泉.png')
    },
    {
        name: '陈智强',
        brief: '富融银行\n首席信息安全官',
        icon: require('./images/陈智强.png')
    },
    {
        name: '孙畅',
        brief: '腾讯云 \n国际战略总监',
        icon: require('./images/孙畅.png')
    },
    {
        name: 'Alvin Kwock',
        brief: 'One Degree\n联合创始人及CEO',
        icon: require('./images/Alvin Kowk.png')
    },
    {
        name: '黄俊瑯',
        brief: '高诺国际加速器\n行政总裁',
        icon: require('./images/黄俊琅.png')
    },
    {
        name: 'Alex',
        brief: 'IOBC Capital \n投资总监',
        icon: require('./images/Alex.png')
    },
    {
        name: 'Steve Li',
        brief: 'Dehash \n首席执行官',
        icon: require('./images/Steve Li.png')
    },
    {
        name: 'Karma Pocket',
        brief: '8DAO\n发起人',
        icon: require('./images/Karma Pocket.png')
    },
    {
        name: 'Joseph Zhang',
        brief: 'Hyper BC\n首席执行官',
        icon: require('./images/Joseph Zhang.png')
    },
    // {
    //     name: '陈钟',
    //     brief: '北京大学教授\n区块链研究中心主任',
    //     icon: require('./images/陈钟.png')
    // },
    {
        name: '卢柏龙',
        brief: '芳信评级\n联合创始人',
        icon: require('./images/卢柏龙.png')
    },
    {
        name: '于佳宁',
        brief: 'Uweb校长，中国通信工业协会区块链专委 共同主席',
        icon: require('./images/于佳宁.png')
    },
    {
        name: 'Kevin Shao',
        brief: 'Bitrise Capital\n合伙人',
        icon: require('./images/Kevin Shao.png')
    },
    // {
    //     name: '小岛美奈子',
    //     brief: 'Meta Network \n创始⼈',
    //     icon: require('./images/小岛美奈子.png')
    // },
    {
        name: 'Austin Lai',
        brief: 'NAGA \n联合创始人',
        icon: require('./images/Austin Lai.png')
    },
    {
        name: 'Tracy Zhang',
        brief: 'Cointelegraph华语\n首席执政官',
        icon: require('./images/Tracy Zhang.png')
    },
    {
        name: 'Leon Liu',
        brief: 'CrossSpace\n联合创始人&首席执行官',
        icon: require('./images/Leon Liu.png')
    },
    {
        name: 'Alma',
        brief: '0xCUHX 创始人\n ReverseDao 首席营销官',
        icon: require('./images/Alma.png')
    },
    // {
    //     name: '林晗',
    //     brief: '比特大陆市场总监',
    //     icon: require('./images/Susan Han.png')
    // },
    {
        name: 'Sea Dune',
        brief: 'Element\n运营总监',
        icon: require('./images/Sea Dune.png')
    },
    {
        name: 'Dr.Peet',
        brief: 'Trusta Labs\n首席执行官 & 创始人',
        icon: require('./images/Dr. Peet.png')
    },
    {
        name: 'Susan Han',
        brief: 'Athena Ventures 联合创始人&首席执政官\n Hiblock 联合创始人',
        icon: require('./images/Susan Han.png')
    },
    {
        name: 'Gary Tiu',
        brief: 'Custonomy\n联合创始人&首席技术官',
        icon: require('./images/Gary Tiu.png')
    },
    {
        name: 'Raymond Lam.',
        brief: 'OSL执行董事及法规事务主管',
        icon: require('./images/Alex1.png')
    },
    {
        name: '黄子权',
        brief: 'EVG\n联合创始人',
        icon: require('./images/黄子权.png')
    },
    {
        name: 'Ciara Sun',
        brief: 'C2 Ventures创始人',
        icon: require('./images/Ciara Sun.png')
    },
    {
        name: 'HC',
        brief: 'Aptos亚太负责人',
        icon: require('./images/HC.png')
    },
    {
        name: '赵晨',
        brief: 'Web3犹太人主任',
        icon: require('./images/赵晨.png')
    },
    {
        name: 'JZ',
        brief: 'HashKey\n投研总监',
        icon: require('./images/JZ.png')
    },
    {
        name: '王鹏宇',
        brief: 'Particle Network创始人',
        icon: require('./images/王鹏宇.png')
    },
    {
        name: '刘松',
        brief: 'BitiZen',
        icon: require('./images/刘松.png')
    },
    {
        name: '黑铁',
        brief: 'DeBox\n联合创始人',
        icon: require('./images/黑铁.png')
    },
    {
        name: '胡学波',
        brief: '门塔科技 首席执政官\nMetaEstate 合伙人',
        icon: require('./images/胡学波.png')
    },
    {
        name: 'Stronger',
        brief: 'Yo数字厂牌\n主理人',
        icon: require('./images/Stronger.png')
    },
    {
        name: 'Nick',
        brief: 'Cryptopunks华语\n社区发起人',
        icon: require('./images/Nick.png')
    },
    {
        name: 'Nick Tang',
        brief: 'Index Game\n业务战略于伙伴关系主管',
        icon: require('./images/Nick Tang.png')
    },
    {
        name: 'Kevin Lee',
        brief: 'HEPHA Holdings\n联合创始人暨新政总裁',
        icon: require('./images/Kevin Lee.png')
    },
    {
        name: 'Linda Chan',
        brief: 'Moonland Metaverse\n新政总裁',
        icon: require('./images/Linda Chan.png')
    },
    {
        name: 'Benny Ho',
        brief: 'Animoca Brands\n商务部负责人',
        icon: require('./images/Benny Ho.png')
    },
    {
        name: '柴舸洋',
        brief: 'TAGGING创始人\n香港政协青年协会 副主席',
        icon: require('./images/柴舸洋.png')
    },
    {
        name: 'Peter@dw3',
        brief: 'DVol.f inance\n联合创始人',
        icon: require('./images/Peter Wei.png')
    },
    {
        name: '彭宗欣',
        brief: '高峰集团\n合伙人',
        icon: require('./images/彭宗欣.png')
    },
    {
        name: 'NiKi',
        brief: '广州大西洲科技有限公司\n运营总监',
        icon: require('./images/NiKi.png')
    },
    {
        name: 'Loki',
        brief: 'Senet Network Technology Co., Limited CEO & Chairman',
        icon: require('./images/Loki.png')
    },
    {
        name: 'Wade Deng',
        brief: 'Footrace\nCEO',
        icon: require('./images/邓维.png')
    }
]

export const logolist = [
    {
        type: 0,
        title: '首席战略合作',
        list: [
            require('./images/sx/sx1.png'),
            require('./images/sx/sx2.png'),
            require('./images/sx/sx3.png'),
            require('./images/sx/sx4.png'),
            require('./images/sx/sx5.png'),
            require('./images/sx/sx6.png'),
            require('./images/sx/sx7.png'),
            require('./images/sx/sx8.png'),
            require('./images/sx/sx9.png'),
            require('./images/sx/sx10.png'),
            require('./images/sx/sx11.png'),
            require('./images/sx/sx12.png'),
            require('./images/sx/sx13.png'),
            require('./images/sx/sx14.png'),
            require('./images/sx/sx15.png')
        ]
    },
    {
        type: 1,
        title: '特邀媒体',
        list: [
            require('./images/ty/ty1.png'),
            require('./images/ty/ty2.png'),
            require('./images/ty/ty3.png'),
            require('./images/ty/ty4.png'),
            require('./images/ty/ty5.png'),
            require('./images/ty/ty6.png'),
            require('./images/ty/ty7.png'),
            require('./images/ty/ty8.png'),
            require('./images/ty/ty9.png'),
            require('./images/ty/ty10.png')
        ]
    },
    {
        type: 0,
        title: '战略媒体',
        list: [
            require('./images/zl/zl1.png'),
            require('./images/zl/zl2.png'),
            require('./images/zl/zl3.png'),
            require('./images/zl/zl4.png'),
            require('./images/zl/zl5.png'),
            require('./images/zl/zl6.png'),
            require('./images/zl/zl7.png'),
            require('./images/zl/zl8.png'),
            require('./images/zl/zl9.png'),
            require('./images/zl/zl10.png'),
            require('./images/zl/zl11.png'),
            require('./images/zl/zl12.png'),
            require('./images/zl/zl13.png'),
            require('./images/zl/zl14.png'),
            require('./images/zl/zl15.png'),
            require('./images/zl/zl16.png'),
            require('./images/zl/zl17.png'),
            require('./images/zl/zl18.png')
            // require('./images/zl/zl19.png')
        ]
    },
    {
        type: 0,
        title: '社区支持',
        list: [
            require('./images/sq/sq1.png'),
            require('./images/sq/sq2.png'),
            require('./images/sq/sq3.png'),
            require('./images/sq/sq4.png'),
            require('./images/sq/sq5.png'),
            require('./images/sq/sq6.png'),
            require('./images/sq/sq7.png'),
            require('./images/sq/sq8.png'),
            // require('./images/sq/sq21.png'),
            require('./images/sq/sq9.png'),
            require('./images/sq/sq10.png'),
            require('./images/sq/sq11.png'),
            require('./images/sq/sq12.png'),
            require('./images/sq/sq13.png'),
            require('./images/sq/sq14.png'),
            require('./images/sq/sq15.png'),
            // require('./images/sq/sq16.png'),
            require('./images/sq/sq17.png'),
            require('./images/sq/sq18.png'),
            require('./images/sq/sq19.png'),
            require('./images/sq/sq20.png'),
            require('./images/sq/sq22.png'),
            require('./images/sq/sq23.png')
        ]
    }
]

export const groupList = (array = [], subGroupLength = 0) => {
    let index = 0
    const newArray = []
    while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength))
    }
    return newArray
}

export default {
    agenderlist,
    guestlist,
    // sessionlist,
    logolist,
    groupList,
    guestLists
}
